module.exports = __webpack_public_path__ + "img/candidates.2cead544.svg";